// extracted by mini-css-extract-plugin
module.exports = {"date":"inputDate_date__34aOo","block":"inputDate_block__33_AU","inline":"inputDate_inline__aBhx3","inlineWarningOrError":"inputDate_inlineWarningOrError__3vypo"};